import type { ReactNode } from 'react';
import { createStore } from '../../lib/store';

export interface ToastItem {
  id: number;
  title: ReactNode;
  description?: ReactNode;
  tone: 'info' | 'success' | 'warning' | 'danger';
  /** ms; default 6000. Errors default to 10000. */
  duration?: number;
}

export const toastStore = createStore<ToastItem[]>([]);
let nextId = 1;

/**
 * Show a short confirmation, e.g. `toast({ title: 'Gift saved', tone: 'success' })`.
 * Keep it short. Important errors belong in an inline <Alert>, not only a toast.
 */
export function toast(t: Omit<ToastItem, 'id' | 'tone'> & { tone?: ToastItem['tone'] }): number {
  const id = nextId++;
  toastStore.set((prev) => [...prev, { ...t, tone: t.tone ?? 'info', id }]);
  return id;
}

export function dismissToast(id: number): void {
  toastStore.set((prev) => prev.filter((t) => t.id !== id));
}
